<template>
  <el-col :span="23">
    <el-form ref="form" :model="form" label-width="140px" class="form">
      <create1
        ref="create"
        :projectArr="projectArr"
        :teamArr="teamArr"
        :userData="userData"
        :formByFather="form"
      ></create1>

      <div class="tip" style="margin: 20px 0 0 40px">* 相关附件</div>
      <div class="clear">
        <el-form-item label="上传附件">
          <attachments
            :projectId="form.projectId"
            :contractId="form.contractId"
            ref="attachments"
            :arr="attachmentArr"
            :type="2"
          ></attachments>
        </el-form-item>
      </div>

      <div class="tip" style="margin: 20px 0 0 40px">* 意见与审批</div>
      <div class="clear label-mx">
        <el-form-item label="审批方式">
          <div class="approve">
            <el-radio v-model="approvalType" label="0">顺序审批</el-radio>
            <el-radio v-model="approvalType" label="1">平行审批</el-radio>
          </div>
        </el-form-item>

        <!-- 审批 -->
        <approval-item
          ref="approval"
          :approvalUsers="approvalUsers.c2_5"
          :selectArr="selectArr"
          :approvalSetDep="approvalSetDep"
        ></approval-item>
      </div>

      <div class="tip tip-table">
        <p><span class="tip-lable">注：</span>1、本表适合集团项目需求的申请报批，由项目需求申报单位填写，报集团公司审批通过后项目实施单位进行下一步工作；</p>
        <p>2、本表上报至集团公司后，在各项条件均符合情况下，审批周期为十个工作日内完成；</p>
        <p>3、在前期工作及施工要求栏，需填报前期工作是否需要设计，前期办理工作时间，施工计划时间要求等，实际完成时间根据项目进展情况跟踪填写；</p>
        <p>4、批准的项目实施类别由战略企划部填写。</p>
      </div>

      <el-form-item label="">
        <div class="form-btn-room">
          <el-button
            :loading="formLoading"
            @click="createProject()"
            class="form-btn"
            type="success"
            >{{ formBtnText }}</el-button
          >
          <el-button
            @click="$router.back()"
            v-if="form.applyId"
            type="info"
            plain
            >取消修改</el-button
          >
        </div>
      </el-form-item>
    </el-form>

    <!-- 保存草稿 -->
    <auto-save
      :form="form"
      :saveName="'Create6'"
      @getForm="getFormData"
      @updateForm="updateForm"
    ></auto-save>
  </el-col>
</template>


<script>
import { mapState } from "vuex";
// import approval from '@/Mixins/approval'
// import Attachments from '@/components/Attachments'
import approvalUsers from "@/Mixins/approvalUsers";

import Attachments from "@/components/Attachments";
import ApprovalItem from "@/components/ApprovalItem";
import Create1 from "@/page/form/create1";

import AutoSave from "@/components/AutoSave";
import saveForm from "@/Mixins/saveForm";
export default {
  components: {
    ApprovalItem,
    Create1,
    Attachments,
    AutoSave,
  },
  props: ["teamArr", "projectArr", "objectType"],
  mixins: [approvalUsers, saveForm],
  computed: {
    ...mapState({
      userData: (state) => state.main.userData,
    }),
  },
  data() {
    return {
      formDefault: {},
      form: {
        depId: "",
        leaderId: "",
        teamId: "",
        level: 0,
        parentProjectId: "",
        // 子项目类型
        ctype: "",

        name: "",
        iszb: "1",
        intro: "",

        xmgs: "",
        xmgq: "",
        zjly: "",

        nwtsjdw: "",
        pzsjdw: "",
        jysgdw: "",
        pzsgdw: "",
        jhpssj: "",
        jhgspfsj: "",
        zbbasj: "",
        sgzbwcsj: "",
        clwczbsj: "",
        sbwczbsj: "",
        jhkgsj: "",
        jhwgsj: "",

        underLine: "",

        // 是否委托设计
        iswtsj: true,
        // 委托设计发包方式
        sjdwfbfs: "",
        // 实施类别
        sslb: "",
        // 微型项目类别 A
        wxType: "",
      },

      // 附件
      attachmentArr: [],
      // 审批
      approvalType: "0",
      // approvalUserIds: "",

      formLoading: false,

      applyInfo: "",
      formBtnText: "确认提交项目申请",
    };
  },
  created() {
    this.form.wxType = this.objectType;
    this.formDefault = JSON.parse(JSON.stringify(this.form));
    this.getApplyData();
  },
  mounted() {
    // this.form.depId = this.userData.secDepIds.split(",")[0]
    // this.form.leaderId = this.userData.id
  },
  methods: {
    getApplyData() {
      this.form.applyId = this.$route.params.applyId;
      if (this.form.applyId) {
        this.formLoading = true;
        this.getProjectApplyInfo();
        this.formBtnText = "确认修改项目申请表";
      } else {
        this.form = JSON.parse(JSON.stringify(this.formDefault));
        this.attachmentArr = [];
        this.applyInfo = "";
        this.setSelectArr(this.applyInfo, 2, 5);
        this.formLoading = false;
        this.formBtnText = "确认提交项目申请";
      }
    },
    getProjectApplyInfo() {
      ajax.get("/gc/project/apply/info/" + this.form.applyId, "", (res) => {
        this.applyInfo = res.vo;

        this.form.depId = this.applyInfo.project.depId;
        this.form.leaderId = this.applyInfo.project.leader.id;
        this.form.teamId = this.applyInfo.project.team
          ? this.applyInfo.project.team.id
          : "";
        this.form.level = this.applyInfo.project.level;
        if (this.applyInfo.project.father) {
          this.form.parentProjectId = this.applyInfo.project.father.id;
        }

        this.form.name = this.applyInfo.project.name;
        this.form.iszb = this.applyInfo.iszb.toString();
        this.form.intro = this.applyInfo.intro;

        this.form.xmgs = this.applyInfo.xmgs;
        this.form.xmgq = this.applyInfo.xmgq;
        this.form.zjly = this.applyInfo.zjly;

        this.form.nwtsjdw = this.applyInfo.nwtsjdw;
        this.form.pzsjdw = this.applyInfo.pzsjdw;
        this.form.jysgdw = this.applyInfo.jysgdw;
        this.form.pzsgdw = this.applyInfo.pzsgdw;

        this.form.jhpssj = this.applyInfo.jhpssj;
        this.form.jhgspfsj = this.applyInfo.jhgspfsj;
        this.form.zbbasj = this.applyInfo.zbbasj;
        this.form.sgzbwcsj = this.applyInfo.sgzbwcsj;
        this.form.clwczbsj = this.applyInfo.clwczbsj;
        this.form.sbwczbsj = this.applyInfo.sbwczbsj;
        this.form.jhkgsj = this.applyInfo.jhkgsj;
        this.form.jhwgsj = this.applyInfo.jhwgsj;

        this.form.underLine = this.applyInfo.underLine.toString();

        this.form.iswtsj = this.applyInfo.iswtsj ? true : false;
        this.form.sjdwfbfs = this.applyInfo.sjdwfbfs;
        this.form.sslb = this.applyInfo.sslb;
        this.form.wxType = this.applyInfo.wxType;

        this.attachmentArr = this.applyInfo.attachments
          ? this.applyInfo.attachments
          : [];

        this.setSelectArr(this.applyInfo, 2, 5);
        this.formLoading = false;
      });
    },
    // 提交项目申请
    createProject() {
      this.form = this.$refs.create.getFromData();
      if (this.form.underLine == "") {
        this.$message.error("请标注本次审批是否已线下通过");
        return;
      }

      if (!this.form.name || !this.form.intro) {
        this.$message.error("项目名称与项目介绍不能为空");
        return;
      }

      // 判断选择了子项目，但父项目未选的情况下，提示
      if (this.form.level == 1 && !this.form.parentProjectId) {
        this.$message.error("该项目你选择了子项目类型，请选择对应的父项目");
        return;
      }

      this.form.type = 5;
      this.form.approvalType = this.approvalType;
      this.form.approvalUserIds = this.$refs.approval.getUserIds();
      if (!this.form.approvalUserIds) {
        this.$message.error("审批人员不能一个都不选择");
        return;
      }
      this.form.attachments = this.$refs.attachments.getAttachments();

      this.formLoading = true;

      let _url = !this.form.applyId
        ? "/gc/project/apply"
        : "/gc/project/apply/edit";

      ajax.post(
        _url,
        this.form,
        (res) => {
          this.formLoading = false;
          if (!this.form.applyId) {
            this.$message.success("提交项目申请成功，请耐心等待领导审批");
          } else {
            this.$message.success("修改项目成功，请耐心等待领导审批");
          }
          this.$router.push("/Project/Detail/" + res.vo.project.id);
        },
        (res) => {
          this.formLoading = false;
        }
      );
    },
  },
  watch: {
    $route() {
      this.getApplyData();
    },
    objectType() {
      this.form.wxType = this.objectType;
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/page/project/formLayout/create_6.vue